<template>
  <div>
    <div class="content">
      <div class="page_head">
        <div class="breadcrumbs">
          <a href="/" class="b_link">Главная</a>
          <span class="b_link">
                    Где купить
                  </span>
        </div>
        <h1 class="title">Где купить</h1>
      </div>
    </div>
    <div class="content border top-regions">
        <ul>
            <li :class="{'active' : inetshopMode}" @click="inetshopMode=true" v-if="inetshops.length">Интернет-магазины</li>
            <li v-for="region in topRegions" :key="region.id" @click="selectTopRegion(region.id)" :class="{'active' : region.id == currentParentRegionId && !inetshopMode}">{{ region.name }}</li>
        </ul>
    </div>
    <div class="content border bootstrap pt-4 pb-4" v-show="inetshopMode">
      <div class="row" style="padding-top: 60px;">
        <div class="col-md-4 pl-4 pb-4" v-for="shop in inetshops" :key="shop.name">
          <div class="pl-4 pb-4">
            <h4>{{ shop.name }}</h4>
            <p v-if="shop.phone">Телефон: {{ shop.phone }}</p>
            <p v-if="shop.email">E-mail: {{ shop.email }}</p>
            <p>Сайт: <a :href="shop.url" target="_blank">{{ shop.url }}</a></p>
            <p><span class="badge " v-for="vendor in shop.vendors" :key="vendor">{{ vendor}}</span></p>
          </div>
        </div>

      </div>
    </div>
    <div class="content border vendors"  v-show="!inetshopMode && showBrands">
        <ul>
            <li v-for="vendor in vendors" :key="vendor.id" @click="selectVendor(vendor.id)" :class="{'active' : vendor.id == currentVendorId}">{{ getBrandUcFirst(vendor.name) }}</li>
        </ul>
    </div>

    <div class="filterMap" v-show="!inetshopMode">
      <div class="content">
        <div class="filterMap_item">
          <label class="filterMap_label" v-show="currentParentRegionId==1">
            <select  id="secondRegionsSelect" class="filterMap_select" name="position">
              <option value="">Выберите регион...</option>
              <option :value="region.id" v-for="region in secondRegions" :key="region.id"
                      :selected="region.id==currentSecondRegionId">{{ region.name }}
              </option>
            </select>
          </label>
        </div>
<!--        <div class="filterMap_box nbf-item" data-width="768">-->
<!--          <div class="filterMap_item checkbox" v-for="channel in channels" :key="channel.id">-->
<!--            <label class="filterMap_label" @click="toggleChannelState(channel.id)"  :class="{'active' : isChannelSelected(channel.id)}">-->
<!--              {{ channel.name }}-->
<!--            </label>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="searchSpace" v-show="!inetshopMode">
      <div class="content border">
        <form method="POST" action="" class="searchSpace_box">
          <div class="searchSpace_input">
            <input
                v-model="searchString"
                type="text"
                placeholder="Введите название, телефон или адрес "
            />
          </div>
          <button type="submit" class="searchSpace_btn"></button>
        </form>
      </div>
    </div>


    <div class="wbMap" v-show="!inetshopMode">
      <div class="content border">
        <div class="wbMap_points">
          <div class="point" :data-id="seller.id" v-for="seller in filteredSellers" :key="seller.id"
               :class="{'active' : seller.id == openSellerId}">
            <div class="point_btn" @click="seller.id == openSellerId ? openSellerId=null : openSellerId=seller.id;">
              <div class="point_title">{{ seller.name }}</div>
            </div>
            <div class="point_content" v-for="address in seller.seller_addresses_filtered" :key="address.id">
              <div class="point_item">
                <div class="point_location">
                  {{ address.name }}
                </div>
                <div class="point_phone">
                  <a :href="'tel:'+ address.phone">{{ address.phone }}</a>
                </div>
                <div class="point_mail">
                  <a :href="'mailto:' + address.email">{{ address.email }}</a>
                </div>
                <div class="point_link hoverLineMoved def-gray">
                  <a :href="address.url">{{ address.url }}</a>
                </div>
                <div class="point_location" v-if="address.info">
                  {{ address.info }}
                </div>
                <div class="grey_items">
                    {{ joinItems(address.channels, '&nbsp;&nbsp;/&nbsp;&nbsp;') }}
                </div>
                <div class="grey_items">
                    {{ joinItems(address.vendors, '&nbsp;/&nbsp;', true) }}
                </div>
                  <div class="grey_items" v-show="address.longitude">
                      <span @click="selectBalloon(address)" class="show-on-map">показать на карте</span>
                  </div>
              </div>
            </div>
          </div>
          <div class="bootstrap" v-if="!filteredSellers.length">
            <h4 class="text-center">Не найдено результатов</h4>
          </div>
        </div>
        <div class="wbMap_map" v-show="filteredSellers.length">
          <yandex-map
              ref="ymap"
              :bounds="mapBounds"
              :coords="coords"
              :zoom="10"
              :cluster-options="clusterOptions"
              @map-was-initialized="mapInit"
          >
            <ymap-marker
                v-for="address in filteredAddressesCoordinate" :key="address.id"
                :coords="address.coords"
                :marker-id="address.id"
                :icon="createMarker()"
                :balloon="{header: getHeader(address), body: getBody(address)}"
                cluster-name="1"
            />
          </yandex-map>
        </div>
      </div>

    </div>

    <!--  <ymap-marker
             v-for="address in filteredAddressesCoordinate" :key="address.id"
             :coords="address.coords"
             :marker-id="address.id"
             hint-content="address.name"
     ></ymap-marker> -->

  </div>
</template>
<script>
import {_} from 'vue-underscore';

export default {
  name: "WhereToBuy",
  props: ['regions', 'sellers', 'channels', 'vendors', 'inetshops'],
  data() {
    return {
      searchString: null,
      ymap: null,
      coords: [
        55.751244,
        37.618423,
      ],
      clusterOptions: {
        1: {
          gridSize: 60,
          preset: "islands#invertedVioletClusterIcons",
          clusterIcons: [
            {
              href: "/cloudmill/images/map.png",
              size: [66, 66],
              offset: [-33, -33]
            }
          ],
          groupByCoordinates: false,
          clusterIconColor: "black",
          clusterHideIconOnBalloonOpen: false,
          geoObjectHideIconOnBalloonOpen: false
        },
      },
      subRegionId: null,
      openSellerId: null,
      currentVendorId: null,
      currentParentRegionId: 1,
      currentSecondRegionId: null,
      selectedChannelId: [],
      inetshopMode: false
    }
  },
  computed: {
    topRegions() {
      return this.regions.filter(region => region.parent_id === 0)
    },
    secondRegions() {
      return this.regions.filter(region => region.parent_id == this.currentParentRegionId)
    },
    showBrands(){
      return !window.postfix
    },
    filteredSellers() {
      let filteredSellers = this.sellers.filter(seller => {
        return seller.seller_addresses.filter(
            (address) => {
//              console.log('address', address, this.currentSecondRegionId)
              const fcond = (this.currentParentRegionId == 1 && ((this.currentSecondRegionId && address.parent_region_id.indexOf(this.currentSecondRegionId.toString()) > -1) || !this.currentSecondRegionId))
              const scond = (this.currentParentRegionId != 1 && address.parent_region_id.indexOf(this.currentParentRegionId.toString()) > -1)
              const tcond = !this.currentVendorId || (this.currentVendorId && address.vendors.filter(vendor => vendor.id == this.currentVendorId).length > 0)
              return (fcond || scond) && tcond
            }
        ).length > 0
      })

      console.log('Filtered Seller', filteredSellers.length)

      if (this.searchString) {
        filteredSellers = filteredSellers.filter(seller => {
          if (seller.name.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1) {
            return true
          }
          return seller.seller_addresses.filter(
              (address) => {
                const con1 = address.name.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
                const con2 = address.phone.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
                const con3 = address.email.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
                const con4 = address.url.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
                return con1 || con2 || con3 || con4
              }
          ).length > 0
        })
      }

      if (this.selectedChannelId.length) {
        filteredSellers = filteredSellers.filter(seller => {
          return seller.seller_addresses.filter(
              (address) => {
                return _.intersection(address.channels.map(channel => channel.id), this.selectedChannelId).length > 0
              }
          ).length > 0
        })
      }

      filteredSellers = filteredSellers.map((seller) => {
        seller.seller_addresses_filtered = seller.seller_addresses.filter(
            (address) => {
              if (this.searchString) {
                const con1 = address.name.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
                const con2 = address.phone.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
                const con3 = address.email.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
                const con4 = address.url.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1

                if (!con1 && !con2 && !con3 && !con4 && seller.name.toLowerCase().indexOf(this.searchString.toLowerCase()) == -1) {
                  return false
                }
              }

              if (this.selectedChannelId.length) {
                return _.intersection(address.channels.map(channel => channel.id), this.selectedChannelId).length > 0
              }

              const fcond = (this.currentParentRegionId == 1 && ((this.currentSecondRegionId && address.parent_region_id.indexOf(this.currentSecondRegionId.toString()) > -1) || !this.currentSecondRegionId))
              const scond = (this.currentParentRegionId != 1 && address.parent_region_id.indexOf(this.currentParentRegionId.toString()) > -1)
              const tcond = !this.currentVendorId || (this.currentVendorId && address.vendors.filter(vendor => vendor.id == this.currentVendorId).length > 0)
              return (fcond || scond) && tcond
            }
        )
        if (this.selectedChannelId.length) {
          filteredSellers = filteredSellers.filter(seller => {
            return seller.seller_addresses.filter(
                (address) => {
                  return _.intersection(address.channels.map(channel => channel.id), this.selectedChannelId).length > 0
                }
            ).length > 0
          })
        }
        return seller
      })


      // if(filteredSellers.length > 200){
      //     filteredSellers = filteredSellers.slice(0, 200)
      // }

      return filteredSellers
    },
    filteredAddressesCoordinate() {
      let keys = []
      let out = []
      this.$log(this.filteredSellers);
      this.filteredSellers.map(seller => {
        seller.seller_addresses_filtered.map(address => {
          const localKey = address.latitude + '-' + address.longitude
          if (address.latitude && address.longitude && keys.indexOf(localKey) == -1) {
            out.push({
              id: address.id,
              name: seller.name,
              address: address.name,
              phone: address.phone,
              email: address.email,
              url: address.url,
              coords: [parseFloat(address.latitude), parseFloat(address.longitude)]
            });
            keys.push(localKey);
          }
        })
      })

      return out
    },
    mapBounds() {
      let minX = 1000;
      let minY = 1000;
      let maxX = 0;
      let maxY = 0;
      this.filteredAddressesCoordinate.map(address => {
        if (address.coords[0] < minX) {
          minX = address.coords[0]
        }
        if (address.coords[1] < minY) {
          minY = address.coords[1]
        }
        if (address.coords[0] > maxX) {
          maxX = address.coords[0]
        }
        if (address.coords[1] > maxY) {
          maxY = address.coords[1]
        }
      })

      if (minX == 1000) {
        return [
          [45, 45], [55, 55]
        ]
      }

      if (minX == maxX) {
        return [
          [minX - 0.002, minY - 0.002], [maxX + 0.002, maxY + 0.002]
        ]
      }

      return [
        [minX, minY], [maxX, maxY]
      ]
    }
  },
  methods: {
    getHeader(address) {
      return '<b style="font-weight: bold;">' + address.name + '</b>';
    },
    getBody(address) {
      return '<ul style="padding-left: 0px; font-size: 80%;">' +
          '<li><b style="font-weight: bold;">Адрес:</b> ' + address.address + '</li>' +
          '<li><b style="font-weight: bold;">Телефон:</b> ' + address.phone + '</li>' +
          (address.email ? '<li><b style="font-weight: bold;">E-mail:</b> ' + address.email + '</li>' : '') +
          (address.url ? '<li><b style="font-weight: bold;">Сайт:</b> <a target="_blank" href="http://' + address.url + '"> ' + address.url + '</li>' : '') +
          '<li>' + (address.info || '') + '</li>' +
          '</ul>';
    },
    selectTopRegion(regionId) {
        this.currentParentRegionId = regionId
        this.inetshopMode = false
    },
    selectVendor(vendorId) {
        this.currentVendorId = vendorId
    },
    getBrandUcFirst(name) {
        return 'TM ' + name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
    },
    createMarker() {
      return {
        layout: 'default#imageWithContent',
        imageHref: '/cloudmill/images/map.png',
        imageSize: [66, 66],
        imageOffset: [-33, -33],
      }
    },
    changeTopRegion(id) {
      // console.log(this.$refs.ymap)
      this.currentParentRegionId = id
      // console.log(this.currentParentRegionId);
    },
    changeSecondRegion(id) {
      this.currentSecondRegionId = id
    },
    toggleChannelState(id) {
      if (this.selectedChannelId.indexOf(id) > -1) {
        this.selectedChannelId = this.selectedChannelId.filter(channelId => channelId != id)
      } else {
        this.selectedChannelId.push(id)
      }
    },
    isChannelSelected(id) {
      return this.selectedChannelId.indexOf(id) > -1
    },
    mapInit(payload) {
      this.ymap = payload;
      this.ymap.geoObjects.removeAll()
      // this.$log('maps', this.ymap.geoObjects.removeAll())
    },

    joinItems(items, sign, isBrand = false) {
        let that = this
        return items.map(item => isBrand ? that.getBrandUcFirst(item.name) : item.name).join(sign)
    },
    selectBalloon(address) {
        this.ymap.setCenter([parseFloat(address.latitude), parseFloat(address.longitude)], 19)
    }
  },
  mounted() {
    const chr = this.changeTopRegion;
    window.$(document).on("change", "#topRegionsSelect", function () {
      chr(this.value)
    })
    const chrs = this.changeSecondRegion;
    window.$(document).on("change", "#secondRegionsSelect", function () {
      console.log('Second region select', this.value)
      chrs(this.value)
    })

    window.$(".filterMap_select").each(function () {
      window.$(this).select2({
        minimumResultsForSearch: Infinity,
        closeOnSelect: true,
        dropdownParent: window.$(".wrapper .page"),
        dropdownCssClass: "filterMap_select2"
      });
    });
  },
  destroyed() {
    window.$(document).off("change", ".#topRegionsSelect")
  }
}

// .ymap-container {
// filter: grayscale(1) brightness(1.03)!important;
// }
</script>

<style lang="scss" scoped>


.filterMap_label.active::before {
  filter: none !important;
}

.point.active .point_content {
  height: auto !important;
}

.top-regions, .vendors {
    ul {
      margin: 0px;

      li {
        display: inline-block;
        margin: 30px 30px 25px 0;
        padding-bottom: 5px;
        font-size: 120%;
        cursor: pointer;

        &.active {
          cursor: default;
          border-bottom: 2px solid var(--brandColor);
        }
      }

    }

}

.top-regions {
  border-bottom: 1px solid #d9d9d9;
}

.vendors {
  ul {
    li {
      font-size: 100%;
    }
  }
}

.grey_items {
  color: #8a8a8a;
  font-size: 12px;
  line-height: 135%;
  margin: 20px 0 10px 0;
}

.show-on-map {
  cursor: pointer;
}

</style>

